(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swish/components/swish-outage.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swish/components/swish-outage.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$accountservicesR = svs.accountservicesReact.deposit.services.swishSocket,
  subscribe = _svs$accountservicesR.subscribe,
  unsubscribe = _svs$accountservicesR.unsubscribe;
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const Button = svs.ui.ReactButton;
const _svs$accountservicesR2 = svs.accountservicesReact.deposit.helpers.swishOutageHelpers,
  makeMessage = _svs$accountservicesR2.makeMessage,
  makeOutageMessage = _svs$accountservicesR2.makeOutageMessage;
const initialMessages = {
  swish: makeOutageMessage('Swish', true, 'Visa andra insättningsmetoder', () => {}),
  nordea: makeOutageMessage('Nordea', false),
  sss: makeOutageMessage('Swedbank, SEB och Skandiabanken', false),
  bankId: makeMessage('BankId', 'Välj Apple Pay istället om BankID inte fungerar.', true, 'Byt till Apple pay', () => {}),
  maintenanceSwish: makeMessage(_, _, true, () => {}),
  maintenaceBank: makeMessage()
};
const SwishOutage = _ref => {
  let handleSelect = _ref.handleSelect;
  const _useState = useState('swish'),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  const _useState3 = useState({
      swish: {}
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    messages = _useState4[0],
    setMessages = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSwishOutage = _useState6[0],
    setIsSwishOutage = _useState6[1];
  useEffect(() => {
    subscribe(swishData => {
      const isSwishOk = swishData === null || swishData === void 0 ? void 0 : swishData.swishIsOk;
      setIsSwishOutage(!isSwishOk);
      if (isSwishOk) {
        return;
      }
      setCode('swish');
    });
    return unsubscribe(() => {
    });
  }, []);
  useEffect(() => {
    initialMessages.bankId.handleClick = () => handleSelect(paymentTypes.APPLEPAY);
    initialMessages.swish.handleClick = () => {
      handleSelect('open');
    };
    setMessages(initialMessages);
  }, []);
  const _messages$code = messages[code],
    title = _messages$code.title,
    message = _messages$code.message,
    handleClick = _messages$code.handleClick,
    buttonText = _messages$code.buttonText,
    isButton = _messages$code.isButton;
  return (
    React.createElement(React.Fragment, null, isSwishOutage && React.createElement("div", {
      className: "margin-top-2 padding-1 u-border-radius-6 bg-tur-100"
    }, React.createElement("h3", {
      className: "h4 margin-bottom-1"
    }, title), React.createElement("p", null, message), isButton && React.createElement("div", null, React.createElement(Button, {
      block: true,
      onClick: handleClick,
      transparent: true
    }, buttonText))))
  );
};
svs.accountservicesReact.deposit.swish.components.SwishOutage = SwishOutage;

 })(window);